export default __webpack_public_path__ + "static/media/f_md-2.deba6906.svg";